import React from 'react';
import { Box } from '@mui/material';
import { SvgVBars } from '@/components/ds/charts';
import { BUDGET_COLORS } from '@/components/ui';
import { formatCurrencyNoUnit } from '@/lib/formatters';

interface AnnualBudgetChartProps {
  data: Array<{
    name: string;
    budgetValue: number;
  }>;
  referenceLine: {
    value: number;
    label: string;
  };
  seriesLabel: string;
}

export default function AnnualBudgetChart(props: AnnualBudgetChartProps) {
  const itemsWithBudget = props.data.filter(
    (item) => (item.budgetValue ?? 0) > 0,
  );

  const individualBarData = itemsWithBudget.map((item) => item.budgetValue ?? 0);
  const sumOfBudgets = individualBarData.reduce((acc, value) => acc + value, 0);

  const bars = [
    ...itemsWithBudget.map((item) => ({
      v: item.budgetValue ?? 0,
      l: item.name,
      c: BUDGET_COLORS.budget,
    })),
    { v: sumOfBudgets, l: 'TOTAL', c: BUDGET_COLORS.total },
  ];

  const referenceLineValue = props.referenceLine.value;
  const dataMax = individualBarData.length > 0 ? Math.max(...individualBarData) : 0;
  const maxValue = Math.max(referenceLineValue, dataMax, sumOfBudgets, 1);

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <SvgVBars
        data={bars}
        h={450}
        max={maxValue + maxValue * 0.1}
        fmt={formatCurrencyNoUnit}
        refLine={referenceLineValue}
        refLabel={props.referenceLine.label}
      />
    </Box>
  );
}
